import {DropdownWithButton, NavigationButton} from '@hm/fundamental'
import {usePlantHierarchyQuery} from '@hproduce/suite-core'
import {mdiMapMarkerOutline, mdiChevronDown, mdiChevronUp} from '@mdi/js'
import {forwardRef, useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {PlantSelectTree} from '../PlantSelectTree'

import {getHierarchyNodeById} from './getHierarchyNodeNameById'
import {useHierarchyIdFromURL} from './useHierarchyIdFromUrl'

export const PlantSelectButton = () => {
  const {t} = useTranslation()
  // Plant hierarchy is intentionally fetched on mount, not on dropdown open so that data is available immediately
  const {data: plantHierarchyData, isPending} = usePlantHierarchyQuery()

  const [hierarchyId, setHierarchyId] = useHierarchyIdFromURL()

  const onSelectHierarchyLevel = useCallback(
    (hierarchyId: string) => {
      setHierarchyId(hierarchyId)
    },
    [setHierarchyId]
  )

  const label = (() => {
    if (hierarchyId && plantHierarchyData) {
      // unknown ids (no access) are reported by HierarchyIdGuard; keep the picker usable meanwhile
      return (
        getHierarchyNodeById(plantHierarchyData, hierarchyId)?.name ??
        t('suite.header.selectHierarchyLevel')
      )
    }
    return hierarchyId ? t('suite.common.loading') : t('suite.header.selectHierarchyLevel')
  })()

  return (
    <div data-cy="plant_select">
      <DropdownWithButton
        label={label}
        component={forwardRef(({label, onClick, isDropdownOpen}, ref) => (
          <NavigationButton
            ref={ref}
            onClick={onClick}
            icon={mdiMapMarkerOutline}
            rightIcon={isDropdownOpen ? mdiChevronUp : mdiChevronDown}
            data-cy="plant_select_button"
            data-test-id="plant_select_button"
            style={{minWidth: 200}}
          >
            {label}
          </NavigationButton>
        ))}
      >
        <PlantSelectTree
          isLoading={isPending}
          nodes={plantHierarchyData}
          onSelect={onSelectHierarchyLevel}
        />
      </DropdownWithButton>
    </div>
  )
}
